import ajax from '../utils/ajax'

export default {
    boundary: keyword => ajax.get("/api/map/boundary", {params: {keyword: keyword || ""}}),
};
